import { Components, ReactComponent } from '@formio/react'
import { ExtendedComponentSchema } from 'formiojs'
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { LiveViewContainer } from '../../../views/LiveView/LiveViewContainer'

type FormIoRefState = {
    setState: ({ value }: { value: any }) => void
    state: { value: any }
}
type FormIoRefProp = (element: FormIoRefState) => void

// minimum props for integration
type LiveViewProps = {
    formioRef: FormIoRefProp
    onChange: (value: any, flags?: any) => void
}

function LiveView(props: LiveViewProps) {
    const [state, setState] = useState({ value: '' })

    // ref to formio ReactComponent
    useEffect(() => {
        if (props.formioRef) {
            props.formioRef({ state, setState })
        }
    }, [props.formioRef])

    // on value change
    useEffect(() => {
        if (props.onChange) {
            props.onChange(state.value)
        }
    }, [state.value])

    return <div>live view comp</div>
}

export class LiveViewWrapper extends ReactComponent {
    private container?: Element

    static schema(sources: ExtendedComponentSchema = {}) {
        return Components.components.field.schema({
            type: 'liveView',
            label: 'Live View',
            key: 'liveView',
            ...sources
        })
    }

    static get builderInfo() {
        return {
            title: 'Live View',
            icon: 'eye',
            group: 'basic',
            documentation: '#',
            weight: 0,
            schema: LiveViewWrapper.schema()
        }
    }

    constructor(component: any, options: object, data: object) {
        super(component, options, data)
    }

    attachReact(element: Element, ref: FormIoRefProp) {
        this.container = element
        ReactDOM.render(
            <LiveViewContainer
            // formioRef={ref} onChange={this.updateValue}
            />,
            element
        )
    }

    detachReact(element: Element) {
        if (element && this.container) {
            ReactDOM.unmountComponentAtNode(this.container)
        }
    }

    // just a hack fix, TODO: fix on @formio/react
    triggerRootChange(...args: any) {}
}
